<template functional>
  <contract-info :info="props.row" />
</template>
<script>
export default {
  name: 'FieldFormatter',
};
</script>
